import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const CTASection = () => {
  const navigate = useNavigate();

  const handleStartLearning = () => {
    navigate('/authentication-portal');
  };

  const handleViewCourses = () => {
    navigate('/pricing-plans');
  };

  const handleContactUs = () => {
    navigate('/blog-content-hub');
  };

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-gradient-to-br from-primary via-primary/90 to-accent">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center space-y-6 md:space-y-8">
          <div className="space-y-3 md:space-y-4">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-primary-foreground">
              Ready to Transform Your Career?
            </h2>
            <p className="text-base md:text-lg lg:text-xl text-primary-foreground/90 max-w-3xl mx-auto">
              Join 50,000+ students who have successfully landed their dream jobs with EduInterview Pro. Start your journey today with our proven methodology and expert guidance.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6">
            <button 
              onClick={handleStartLearning}
              className="w-full sm:w-auto px-6 md:px-8 py-3 md:py-4 bg-background text-foreground rounded-lg font-medium hover:bg-background/90 transition-base focus-ring flex items-center justify-center space-x-2 shadow-lg"
            >
              <Icon name="Rocket" size={20} color="var(--color-primary)" />
              <span>Start Learning Now</span>
            </button>

            <button 
              onClick={handleViewCourses}
              className="w-full sm:w-auto px-6 md:px-8 py-3 md:py-4 bg-transparent text-primary-foreground border-2 border-primary-foreground rounded-lg font-medium hover:bg-primary-foreground/10 transition-base focus-ring flex items-center justify-center space-x-2"
            >
              <Icon name="BookOpen" size={20} color="var(--color-primary-foreground)" />
              <span>View Courses</span>
            </button>

            <button 
              onClick={handleContactUs}
              className="w-full sm:w-auto px-6 md:px-8 py-3 md:py-4 bg-transparent text-primary-foreground border-2 border-primary-foreground rounded-lg font-medium hover:bg-primary-foreground/10 transition-base focus-ring flex items-center justify-center space-x-2"
            >
              <Icon name="Mail" size={20} color="var(--color-primary-foreground)" />
              <span>Contact Us</span>
            </button>
          </div>

          <div className="pt-6 md:pt-8 border-t border-primary-foreground/20">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 md:gap-8 max-w-3xl mx-auto">
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-bold text-primary-foreground mb-1">
                  30 Days
                </p>
                <p className="text-sm md:text-base text-primary-foreground/80">
                  Money-Back Guarantee
                </p>
              </div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-bold text-primary-foreground mb-1">
                  24/7
                </p>
                <p className="text-sm md:text-base text-primary-foreground/80">
                  Expert Support
                </p>
              </div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-bold text-primary-foreground mb-1">
                  Free Trial
                </p>
                <p className="text-sm md:text-base text-primary-foreground/80">
                  No Credit Card Required
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;